import React from 'react';
import ModuleCard from './ModuleCard';
import EmptyState from '../../../components/states/EmptyState';

const ModulesGridView = ({
  course,
  modules,
  getModuleProgress,
  getModuleThumbnail,
  setSelectedModule,
  onBack,
}) => {
  return (
    <div className="modules-grid-view-wrapper">
      {/* Header */}
      <div className="modules-grid-header">
        <button className="back-btn-icon" onClick={onBack} title="Voltar">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <polyline points="15,18 9,12 15,6" />
          </svg>
          <span>Voltar</span>
        </button>
        <div className="modules-grid-center">
          <h1 className="modules-grid-title">{course.title}</h1>
          <p className="modules-grid-subtitle">{course.description}</p>
          <span className="modules-grid-count">{modules.length} MÓDULOS</span>
        </div>
      </div>

      {/* Modules Grid */}
      <div className="modules-grid-content">
        {modules.length === 0 ? (
          <EmptyState
            title="Nenhum módulo disponível"
            message="Este curso não possui módulos no momento."
            icon={
              <svg
                width="64"
                height="64"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
              >
                <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z" />
                <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" />
              </svg>
            }
          />
        ) : (
          <div className="modules-grid-items">
            {modules.map(module => (
              <ModuleCard
                key={module.id}
                module={module}
                getModuleProgress={getModuleProgress}
                thumbnail={getModuleThumbnail(module)}
                onSelect={() => {
                  // Adiciona courseId ao módulo para referência
                  const moduleWithCourse = { ...module, courseId: course.id };
                  setSelectedModule(moduleWithCourse);
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ModulesGridView;
